import { required, optional, obj } from 'AppReact/schema';

const unit = {
  id: optional('integer'),
  number: optional('string')
}

const category = {
  id: required('integer'),
  name: optional('string'),
  attachment: optional('string'),
  parent: obj({
    id: optional('integer'),
    name: optional('string')
  }),
}

const property = {
  id: required('integer'),
  name: required('string'),
  property_icon: optional('string')
}

const tenant = {
  email: optional('string'),
  first_name: optional('string'),
  id: optional('integer'),
  last_name: optional('string'),
  tenancy_id: optional('integer'),
}

export const order = {
  category: obj(category),
  id: required('integer'),
  request_id: required('integer'),
  inserted_at: required('string'),
  level: required('string'),
  property: obj(property),
  status: required('string'),
  tenant: obj(tenant),
  completed_at: optional('string'),
  assigned_at: optional('string'),
  cancelled_at: optional('string'),
  rating: optional('integer'),
  tech_id: optional('integer'),
  tech_image: optional('string'),
  tech_name: optional('string'),
  vendor_id: optional('integer'),
  vendor_name: optional('string'),
  vendor_url: optional('string'),
  unit: obj(unit),
  events: optional('array'),
}